'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Content_web = require('./Content/Content.web.cjs');
var CheckboxItem_web = require('./Item/CheckboxItem/CheckboxItem.web.cjs');
var Item_web = require('./Item/Item.web.cjs');
var RadioGroup_web = require('./Item/RadioGroup/RadioGroup.web.cjs');
var RadioItem_web = require('./Item/RadioItem/RadioItem.web.cjs');
var SubMenu_web = require('./SubMenu/SubMenu.web.cjs');
var Trigger_web = require('./Trigger/Trigger.web.cjs');

/**
 * The DropdownMenu holds a list of immediate actions.
 *
 * {@link https://aviary.fullscript.io/latest/components/dropdown-menu-1-1/overview-lK32Lu0V | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/molecules/DropdownMenu/DropdownMenu.web.tsx | View in GitLab}
 *
 * @scope Web
 */ const DropdownMenu = ({ isOpen = false, onOpenChange, enableOutsideInteractions = false, children })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
        open: onOpenChange ? isOpen : undefined,
        onOpenChange: onOpenChange,
        modal: !enableOutsideInteractions,
        children: children
    });
};
DropdownMenu.Trigger = Trigger_web.Trigger;
DropdownMenu.Content = Content_web.Content;
DropdownMenu.Item = Item_web.Item;
DropdownMenu.CheckboxItem = CheckboxItem_web.CheckboxItem;
DropdownMenu.RadioGroup = RadioGroup_web.RadioGroup;
DropdownMenu.RadioItem = RadioItem_web.RadioItem;
DropdownMenu.SubMenu = SubMenu_web.SubMenu;

exports.DropdownMenu = DropdownMenu;
//# sourceMappingURL=DropdownMenu.web.cjs.map
